import React, { Component } from 'react';
import $ from 'jquery';

class CancelDocuments extends Component{

    componentDidMount(){
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#cancelDocuments').modal('hide');  
    }

    closeAction = () => {
        $('#cancelDocuments').on('hidden.bs.modal', function () {
        });
    };
    
    render() {
        const {CancelDocuments} = this.props;
        return (
                <div className="modal" tabIndex="-1" role="dialog" id="cancelDocuments" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p>¿Está seguro que deseas cancelar el documento?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={()=>CancelDocuments()}>Confirmar</button>
                                <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
        );  
    }

}
export default CancelDocuments;